<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'loanTime')">
              <a-range-picker v-model="queryParam.lendingTime" format="DD-MM-YYYY" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'custType')">
              <a-select default-value="" style="width: 100%" v-model="queryParam.custType">
                <a-select-option value="">
                  {{ $t('all') }}
                </a-select-option>
                <a-select-option value="1">
                  {{ $t('newCustomer') }}
                </a-select-option>
                <a-select-option value="2">
                  {{ $t('oldCustomer') }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('productType')">
              <a-select v-model="queryParam.appssid">
                <a-select-option v-for="item in appList" :key="item.appssid">
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('orderType')">
              <a-select default-value="" style="width: 100%" v-model="queryParam.orderType">
                <a-select-option value="">
                  {{ $t('all') }}
                </a-select-option>
                <a-select-option value="0">
                  {{ $t('normalOrder') }}
                </a-select-option>
                <a-select-option value="1">
                  {{ $t('extensionOrder') }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{
                $t('reset')
              }}</a-button>
              <!--              <a-button type="primary" @click="downLoadData('')" icon="download" style="margin-left: 8px">Export</a-button>-->
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :rowClassName="rowClassName"
        :pagination="false"
        :loading="loading"
        :scroll="{ x: 'max-content' }"
        bordered
      >
      </a-table>
    </div>
    <v-modal v-model="visible" :title="$t('order.collectionDetail')">
      <div style="padding: 20px">
        <collection-detail
          v-if="visible"
          :orderId="orderId"
          :custInfoId="custInfoId"
          :taskId="taskId"
          :auditDrawer="false"
          @close="visible = false"
        />
      </div>
    </v-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { countInstallmentPlatformLoanDataWithDate, getApplist } from '@/webpublicapi/order'
import { getAllDeadlineConfig } from '@/webpublicapi/deadlineConfig'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import exportFile from '@/webpublicapi/exportFile'
import moment from 'moment'
import vModal from '../modules/Modal'
import { FenToDong } from '@/utils/filter'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.',
}

export default {
  name: 'CountCollectionTaskDispense',
  components: {
    Dict,
    DictSelect,
    vModal,
  },
  data() {
    return {
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      taskId: undefined,
      // Pagination params
      form: {
        pageNum: 1,
        pageSize: 30,
      },
      total: 0,
      dataSource: [],
      appList: [],
      deadlineConfigList: [],
      // Query conditions
      queryParam: {
        orderNo: '',
        appssid: '',
        mobileNo: '',
        orderType: '',
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc',
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 },
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t(I18N_KEY.ORDER + 'paymentTime'),
          align: 'center',
          width: '150px',
          dataIndex: 'paymentTime',
          customRender: (text) => {
            if (!text || text === 'Total') return text
            const m = moment(text, 'DD-MM-YYYY', true)
            if (m.isValid()) return text // If already DD-MM-YYYY Format, return directly

            const m2 = moment(text, 'YYYY-MM-DD', true)
            return m2.isValid() ? m2.format('DD-MM-YYYY') : text
          },
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'loanCount'),
          align: 'center',
          width: '150px',
          dataIndex: 'loanCount',
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'newLoanCount'),
          align: 'center',
          width: '150px',
          dataIndex: 'newLoanCount',
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'jianjunNew'),
          align: 'center',
          width: '150px',
          dataIndex: 'jianjunNew',
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'oldLoanCount'),
          align: 'center',
          width: '150px',
          dataIndex: 'oldLoanCount',
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'jianjunOld'),
          align: 'center',
          width: '150px',
          dataIndex: 'jianjunOld',
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'noRate'),
          align: 'center',
          width: '150px',
          dataIndex: 'noRate',
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'paymentAmtReport'),
          align: 'center',
          width: '150px',
          dataIndex: 'paymentAmt',
          customRender: (text) => FenToDong(text),
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'newPaymentAmt'),
          align: 'center',
          width: '150px',
          dataIndex: 'newPaymentAmt',
          customRender: (text) => FenToDong(text),
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'oldPaymentAmt'),
          align: 'center',
          width: '150px',
          dataIndex: 'oldPaymentAmt',
          customRender: (text) => FenToDong(text),
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'applyAmtReport'),
          align: 'center',
          width: '150px',
          dataIndex: 'applyAmt',
          customRender: (text) => FenToDong(text),
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'newApplyAmt'),
          align: 'center',
          width: '150px',
          dataIndex: 'newApplyAmt',
          customRender: (text) => FenToDong(text),
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'oldApplyAmt'),
          align: 'center',
          width: '150px',
          dataIndex: 'oldApplyAmt',
          customRender: (text) => FenToDong(text),
        },
      ]
    },
  },
  created() {
    getApplist().then((res) => {
      this.appList = res.data || []
    })
    this.getDict()
    this.loadData()
    getAllDeadlineConfig().then((res) => {
      this.deadlineConfigList = res.data || []
    })
  },
  methods: {
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData()
    },
    loadData(arg) {
      // Load data If params passed1Then load first page content
      // if (arg === 1) {
      //   this.form.pageNum = 1
      // }
      this.loading = true
      var params = this.getQueryParams() // Query conditions
      countInstallmentPlatformLoanDataWithDate(Object.assign({}, params))
        .then((res) => {
          if (res.code === 1000) {
            // this.total = res.data.total
            this.dataSource = res.data || []
            if (this.dataSource.length > 0) {
              for (var i = 0; i < this.dataSource.length; i++) {
                var dataO = this.dataSource[i]
                let jianjunOld = Number(dataO.oldLoanCount) ? Number(dataO.oldApplyAmt) / Number(dataO.oldLoanCount) : 0
                dataO.jianjunOld = FenToDong(jianjunOld)
                let jianjunNew = Number(dataO.newLoanCount) ? Number(dataO.newApplyAmt) / Number(dataO.newLoanCount) : 0
                dataO.jianjunNew = FenToDong(jianjunNew)
                dataO.paymentTime = this.transformTime(dataO.paymentTime, 1)
              }
            }
          } else {
            this.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    transformTime(time, flag) {
      if (flag == 1) {
        return moment(time).format('DD-MM-YYYY')
      }
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      const { lendingTime } = this.queryParam
      const data = {
        ...this.queryParam,
        lendingTimeStart: lendingTime && lendingTime.length ? this.transformTime(lendingTime[0]) : undefined,
        lendingTimeEnd: lendingTime && lendingTime.length ? this.transformTime(lendingTime[1]) : undefined,
      }
      delete data.applyDate
      var param = Object.assign({}, data)

      return filterObj(param)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // Reset dictionary type search box content
    searchReset() {
      var that = this
      that.queryParam.lendingTime = undefined
      that.loadData(this.form.pageNum)
    },
    changeModal(visible) {
      this.visible = visible
    },
    downLoadData(arg2) {
      var params = this.getQueryParams(arg2) // Query conditions
      const file = {
        fileUrl:
          '/api/web/platform/order/countLoanDataWithDateExcel?lendingTimeStart=' +
          params.lendingTimeStart +
          '&lendingTimeEnd=' +
          params.lendingTimeEnd +
          '&custType=' +
          params.custType,
        fileName: 'countLoanDataWithDateExcel.xls',
      }
      this.loading = true
      exportFile(file)
        .catch((e) => {
          this.$message.error(e.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    rowClassName(record, index) {
      const date = new Date(record.paymentTime)
      let className = date.getDay() % 6 === 0 ? 'table_weekendColor' : ''
      return className
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';
/deep/ .ant-table-thead > tr > th {
  white-space: nowrap;
}
</style>
